import { Loader } from '@googlemaps/js-api-loader';
import { ReactNode, useEffect, useState } from 'react';

interface GoogleMapsLoaderProps {
    children: ReactNode;
}

const GoogleMapsLoader = ({ children }: GoogleMapsLoaderProps) => {
    const [isLoaded, setIsLoaded] = useState(false);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

        if (!apiKey) {
            console.error(
                'REACT_APP_GOOGLE_MAPS_API_KEY is not set. Please add it to your .env file.'
            );
            setError('Google Maps API key not configured');
            return;
        }

        const loader = new Loader({
            apiKey: apiKey,
            version: 'weekly',
            libraries: ['places', 'geometry'],
            language: 'en'
        });

        loader
            .load()
            .then(() => {
                console.log('Google Maps API loaded successfully');
                setIsLoaded(true);
                setError(null);
            })
            .catch((error) => {
                console.error('Google maps loader error', error);
                setError('Failed to load Google Maps API');
            });
    }, []);

    if (error) {
        console.error('GoogleMapsLoader error:', error);
    }

    return <>{children}</>;
};

export default GoogleMapsLoader;
